// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderBottomOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderBottomOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderBottomOutlined = function PBorderBottomOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderBottomOutlinedSvg
  }));
};

PBorderBottomOutlined.displayName = 'PBorderBottomOutlined';
export default React.forwardRef(PBorderBottomOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderBottomOutlined.js
// module id = 3241
// module chunks = 0